import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=289827be&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=289827be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289827be",
  null
  
)

export default component.exports